class GeotabServiceProvider {
  constructor() {}

  getService() {
    return this.service;
  }

  setService(service) {
    this.service = service;
  }
}

const singletonGeotabServiceProvider = new GeotabServiceProvider();

export default singletonGeotabServiceProvider;